/**
 * @generated SignedSource<<4bdac611040b8aef6b6b90cbba289a98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEstimateSimilarSoldRange_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item" | "pricingGuidanceTracking_item" | "showPricingGuidance_item" | "useGetEstimatedValueRange_item">;
  readonly " $fragmentType": "PdpSharedEstimateSimilarSoldRange_item";
};
export type PdpSharedEstimateSimilarSoldRange_item$key = {
  readonly " $data"?: PdpSharedEstimateSimilarSoldRange_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimateSimilarSoldRange_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v1 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v2 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v3 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "kind": "RootArgument",
    "name": "isTrade"
  },
  {
    "kind": "RootArgument",
    "name": "priceBookName"
  },
  {
    "kind": "RootArgument",
    "name": "userCountryCode"
  },
  {
    "kind": "RootArgument",
    "name": "userId"
  }
],
v7 = {
  "kind": "InlineDataFragmentSpread",
  "name": "pricingGuidanceHelpers_item",
  "selections": [
    {
      "alias": "recommendedPrice",
      "args": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "medianAmount",
          "plural": false,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "minAmount",
          "plural": false,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "maxAmount",
          "plural": false,
          "selections": (v5/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": (v6/*:: as any*/)
},
v8 = [
  (v4/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEstimateSimilarSoldRange_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetEstimatedValueRange_item"
    },
    (v7/*:: as any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "showPricingGuidance_item",
      "selections": [
        (v7/*:: as any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceTracking_item",
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*:: as any*/),
            {
              "kind": "Literal",
              "name": "isBuyerEstimateEnabled",
              "value": true
            },
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": (v8/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "minAmount",
              "plural": false,
              "selections": (v8/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "maxAmount",
              "plural": false,
              "selections": (v8/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": (v6/*:: as any*/)
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "11544e59b10713e53970dbdbf0998708";

export default node;
